let
    lastScrollTop = 0,
    overlayPosition = parseInt(Voonto.$('.cuerpo-texto p:first').offset().top),
    $toolbar = Voonto.$('.herramientas.fija'),
    $document = Voonto.$(document)
;

function handleScroll() {
    Logger.info('SocialToolbar handleScroll');
    let redesSticky;
    if (redesSticky = document.querySelector('.herramientas.fija')) {
        let redes = redesSticky.nextElementSibling;
        let estadoRedes = redes.getBoundingClientRect().bottom > 0 ? redesRelativo() : redesFijo();
        let delay = false;
        let marcador;
        if (marcador = (document.querySelector('.marcador')));
        setTimeout(function () {
            document.addEventListener('scroll', function () {
                if (delay) return;
                if ((redes.getBoundingClientRect().bottom) <= ((marcador) ? marcador.offsetHeight : 0) && estadoRedes === 'relativo') {
                    estadoRedes = redesFijo();
                }
                if ((redes.getBoundingClientRect().bottom) > ((marcador) ? marcador.offsetHeight : 0) && estadoRedes === 'fijo') {
                    estadoRedes = redesRelativo();
                }
                delay = true;
                setTimeout(function () {
                    delay = false;
                }, 50);
            })
        }, 500);
        function redesFijo() {
            redesSticky.classList.add('redesVisible')
            return 'fijo';
        }

        function redesRelativo() {
            redesSticky.classList.remove('redesVisible')
            return 'relativo';
        }
    }
}

class SocialToolbar {
    constructor(form) {
        this.hasToolbar = $toolbar.length !== 0;
        this.isEnabled = false;
    }

    enable() {
        Logger.info('SocialToolbar enable. isEnabled: ' + this.isEnabled);
        if (!this.isEnabled) {
            $document.on('scroll', handleScroll);
            this.isEnabled = true;
        }
    }

    disable() {
        Logger.info('SocialToolbar disable. isEnabled: ' + this.isEnabled);
        if (this.isEnabled) {
            $document.off('scroll', handleScroll);
            this.isEnabled = false;
            let redesSticky = document.querySelector('.herramientas.fija');
            redesSticky.classList.remove('redesVisible')
            /* if ($toolbar.is(':visible')) {
                $toolbar.fadeOut(250);
             }*/
        }
    }
}
export default SocialToolbar;



// WEBPACK FOOTER //
// ./src/scripts/layout/social-toolbar.js